/**
 * Couleur stable dérivée d'une chaîne (même palette / hash que PlayerAvatar).
 */

import type { CSSProperties } from 'react';

const PALETTE = [
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#607d8b',
] as const;

export function colorFromString(s: string): string {
  const key = s.trim() || '?';
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/** Assombrit une couleur hex pour le texte sur fond très clair (verts / jaunes lisibles). */
function mixHexWithBlack(hex: string, blackAmount: number): string {
  const t = Math.min(1, Math.max(0, blackAmount));
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const nr = Math.round(r * (1 - t));
  const ng = Math.round(g * (1 - t));
  const nb = Math.round(b * (1 - t));
  return `#${nr.toString(16).padStart(2, '0')}${ng.toString(16).padStart(2, '0')}${nb.toString(16).padStart(2, '0')}`;
}

/** Styles pour une pill (nom d’équipe, etc.) : fond teinté, bordure, texte assombri pour contraste. */
export function pillStyleFromString(label: string): CSSProperties {
  const base = colorFromString(label);
  return {
    backgroundColor: hexToRgba(base, 0.2),
    borderColor: hexToRgba(base, 0.48),
    color: mixHexWithBlack(base, 0.44),
  };
}
